<template>
    <div>
        <div class="columns">
            <div class="column is-6 is-offset-3">
                <admin-form :admin="admin" :create="false"></admin-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {
                admin: this.$store.state.admin.all.find(admin => admin.id === parseInt(this.$route.params.id))
            }
        },
        computed: mapGetters(['admin']),
    };
</script>



// WEBPACK FOOTER //
// AdminEdit.vue?07bddc44